<template>
  <async-data :request-state="requestState">
    <slot name="default" v-bind:invoice="invoice"
          v-if="requestState === 'Success'">
      <!--WithInvoice body-->
    </slot>
  </async-data>
</template>

<script>
  import AsyncData from "../../Ui/AsyncData";
  import {RequestState} from "../../../requestState";
  import {mapActions} from "vuex";

  export default {
    name: 'with-invoice',
    components: {
      AsyncData,
    },
    props: {
      invoiceId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {}
    },
    mounted() {
      this.invoicesGetInvoiceIfRequired(this.invoiceId)
    },
    methods: {
      ...mapActions({
        invoicesGetInvoiceIfRequired: 'invoicesGetInvoiceIfRequired',
      })
    },
    computed: {
      invoiceInfo() {
        return this.$store.getters.getInvoiceInfoById(this.invoiceId)
      },
      requestState() {
        if (!this.invoiceInfo) {
          return RequestState.NotPerformed
        }

        return this.invoiceInfo.requestState
      },
      invoice() {
        return this.invoiceInfo.response.info
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/WithInvoice.vue